import React, { createContext, useContext, useEffect, useState } from 'react';
import { getUser, getUserNotifications } from "../services/usersManager";
import i18n from "../config/i18n";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [notifications, setNotifications] = useState(null);
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isDarkMode, setIsDarkMode] = useState(false);

    // Function to fetch user and update state
    const refreshUser = async () => {
        setLoading(true);
        try {
            const r = await getUser();
            let newSettings = { ...r.settings };
            newSettings.siteLang = r.user?.settings?.lang || newSettings.siteLang;
            setSettings(newSettings);
            setUser(r.user);
            setIsDarkMode(r.user && r.user.settings && r.user.settings.darkMode);
            i18n.changeLanguage(newSettings.siteLang);
            if (r.user) {
                getUserNotifications().then((r) => setNotifications(r.reverse()));
            }
        } catch (error) {
            console.error("Error fetching user:", error);
            setUser(null);
        }
        setLoading(false);
    };

    // Fetch user on mount
    useEffect(() => {
        refreshUser();
    }, []);

    // Fetch notifications when user is set
    useEffect(() => {
        if (user && notifications === null) {
            getUserNotifications().then((r) => setNotifications(r.reverse()));

            const intervalId = setInterval(() => {
                getUserNotifications().then((r) => setNotifications(r.reverse()));
            }, 1000 * 60 * 5);

            return () => clearInterval(intervalId);
        }
    }, [user, notifications]);

    return (
        <UserContext.Provider value={{
            user, setUser, refreshUser,
            notifications, setNotifications,
            settings, setSettings, loading, isDarkMode
        }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);
